module.exports = __webpack_public_path__ + "static/img/BS.a144b20e.svg";